export const CustomFetch = (expert) => {
    return new Promise((resolve, reject) => {
        resolve(expert)
    })
}